export const REPORTING_DB_NAME = 'reporting_db';
export const REPORTING_DB_SCHEMA = 'reporting';
export const REPORTING_COLLECTION = 'reporting';
export const REPORTING_IMPORTS_COLLECTION = 'imports';
export const REPORTING_RAW_CARRIER_FILES_COLLECTION = 'raw-carrier-files';
export const REPORTING_MODIFIED_CARRIER_FILES_DIRECTORY = 'modified-carrier-files';
export const REPORTING_RAW_CARRIER_FILE_INVALID_ROWS_SUBCOLLECTION = 'invalid-rows';
export const REPORTING_RAW_CARRIER_FILE_PROCESSING_RUNS_SUBCOLLECTION = 'processing-runs';

export enum ReportingDbTableName {
  importRuns = 'import_runs',
  importRows = 'import_rows',
  importRowNormalizationIssues = 'import_row_normalization_issues',
  importRowNormalizationIssueCandidates = 'import_row_normalization_issue_candidates',
  supportingTableImports = 'supporting_table_imports',
  agencyCodeNameMappingRows = 'agency_code_name_mapping_rows',
  agentSuppressionRows = 'agent_suppression_rows',
  agencyNtpRows = 'agency_ntp_rows',
  ntpMgaTerminatedAgentsRows = 'ntp_mga_terminated_agents_rows',
  agencyRmdRows = 'agency_rmd_rows',
  forestersTableRows = 'foresters_table_rows',
  mgaTableRows = 'mga_table_rows',
  nlgProdNameTableRows = 'nlg_prod_name_table_rows',
  agentMgaCorrectionsRows = 'agent_mga_corrections_rows',
  carriersTableRows = 'carriers_table_rows',
  gpmEquisMgaUpdateRows = 'gpm_equis_mga_update_rows',
  supportingTableChangeOutbox = 'supporting_table_change_outbox',
  masterDatasetRuns = 'master_dataset_runs',
  masterDatasetRawRows = 'master_dataset_raw_rows',
  masterRunSupportingSnapshot = 'master_run_supporting_snapshot',
  masterPaid = 'master_paid',
  masterSubmit = 'master_submit',
  masterDatasetChangeLog = 'master_dataset_change_log',
  importSubmit = 'import_submit',
  products = 'products',
  reconciliationManualFigures = 'reconciliation_manual_figures',
}
